// Import model
import { PatternTypeOption } from '../models/PatternTypeOption';

// Import base class serializer
import { EstimateOptionsSerializer } from './EstimateOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PatternTypeOption - handles JSON serialization and deserialization with type validation
 */
export class PatternTypeOptionSerializer {
  /**
   * Deserializes a JSON string into a PatternTypeOption instance
   */
  static deserialize(json: string): PatternTypeOption {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PatternTypeOption instance
   */
  static fromObject(obj: any): PatternTypeOption {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PatternTypeOption');
    }


    const instance: PatternTypeOption = {
      description: obj['description'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      name: obj['name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      type_: obj['type'] as string,
      productType: obj['productType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PatternTypeOption instances
   */
  static deserializeArray(json: string): PatternTypeOption[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PatternTypeOption instance to a JSON string
   */
  static serialize(instance: PatternTypeOption): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PatternTypeOption instance to a plain object
   */
  static toObject(instance: PatternTypeOption): any {
    return {
      'description': instance.description,
      'externalId': instance.externalId,
      'name': instance.name,
      '_id': instance.id,
      'type': instance.type_,
      'productType': instance.productType,
    };
  }

  /**
   * Serializes an array of PatternTypeOption instances to a JSON string
   */
  static serializeArray(instances: PatternTypeOption[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
